import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, reduxForm} from 'redux-form';
import Titulo from '../comum/Titulo';
import {alterouFiltro, alterouPagina} from '../../util/filtros';
import {PERFIL_ADMIN} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import CabecalhoRodapeTabela from '../comum/CabecalhoRodapeTabela';
import buscarPlataformas from '../../actions/empresa/buscarPlataformas';
import {buscarInteressadosPromocao,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
  listarFiltros
} from '../../actions/interessado-promocao/usuariosPromocaoActions';
import InteressadoPromocao from './InteressadoPromocao';
import BotoesPaginacaoInteressados from './BotoesPaginacaoInteressados';
import PaginacaoInteressado from './PaginacaoInteressado';
import PainelFiltragem from './PainelFiltrosInteressados';
import axios from 'axios';
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil';
import {URL} from '../../util/ambienteActions';
import { montarURLFiltro } from '../../util/filtros';

export const CabecalhoTabela = () => (
    <div id="header-tabela" className="lista-table">
        <div className="row cabecalho-desktop">
            <div className="col-sm-12 col-md">Nome</div>
            <div className="col-sm-12 col-md-3">Email</div>
            <div className="col-sm-12 col-md">Telefone</div>
            <div className="col-sm-12 col-md">Origem</div>
            <div className="col-sm-12 col-md">Tipo</div>
            <div className="col-sm-12 col-md">Cid. Origem</div>
            <div className="col-sm-12 col-md">Cid. Destino</div>
            <div className="col-sm-12 col-md">Data de entrada</div>
        </div>
    </div>
);

export class PainelGerenciarInteressadosPromocao extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            usuarioSelecionado: null,
            textoFiltro: null
        };
    }

    componentDidMount() {
        this.props.buscarPlataformas();
        this.buscarInteressados();
        this.props.listarFiltros();
    }

    componentDidUpdate(prevProps) {
        if (alterouPagina(this.props, prevProps) || alterouFiltro(this.props, prevProps)) {
            if (alterouFiltro(this.props, prevProps)) {
                this.props.determinarPaginaAtual(1);
                this.props.alterarRegistrosPorPagina(10);
            }
            this.buscarInteressados()
        }
    }

    buscarInteressados() {
        this.props.buscarInteressadosPromocao(this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
    }

    exibirTabelaInteressados() {
        if (this.props.interessadosPromocao && this.props.interessadosPromocao.length) {
            return (
                <CabecalhoRodapeTabela OpcoesPaginacao={PaginacaoInteressado}
                                       BotoesPaginacao={BotoesPaginacaoInteressados}>
                    <CabecalhoTabela/>
                    <div className="lista-table">
                        {this.exibirInteressados()}
                    </div>
                </CabecalhoRodapeTabela>
            )
        }
        return <div>Nenhum interessado para promoção.</div>;
    }

    exibirInteressados() {
        return this.props.interessadosPromocao
            .map((interessado) => <InteressadoPromocao
              key={interessado.id}
              interessado={interessado}/>)
    }

    async downloadParte(url, size, from) {
        const urlFiltros = montarURLFiltro(this.props.filtrosAdicionados);
        
        let urlReq = `${url}?size=${size}&from=${from}&${urlFiltros}`;
        let retorno = await axios.get(urlReq, SLOW_REQUEST_CONFIG);

        return retorno.data;
    }

    executarDownload(arquivo) {
        let a = window.document.createElement('a');

        a.href = window.URL.createObjectURL(new Blob(['\ufeff', arquivo], {type: 'text/csv;'}));
        a.download = 'Lista de Interessados e Clientes.csv';

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    async exportarListaUsuarios() {
        let arquivo = 'Nome;E-mail;Telefone;Origem;Tipo;Cid.Origem;Cid.Destino;Data de entrada\n';
        let url = `${URL}/promocoes/recebimento/interessados`;

        let count = 0;
        let from = 1;
        let size = 10000;

        let qtd = this.props.total;
        let totalParticoes = Math.ceil(qtd / 10000);

        for (let start = 0; start < totalParticoes; start += 1) {
            let retorno = await this.downloadParte(url, size, from);

            arquivo = `${arquivo}${retorno.interessadosRecebimentoPromocoes.map(it => {

                const telefone = it.telefone ? it.telefone.replace(/\D/g,'').replace(/^(\d{2})(\d)/g,'($1) $2').replace(/(\d)(\d{4})$/,'$1-$2') : 'Sem telefone';
                const origem = it.plataforma ? it.plataforma : 'Não informado';
                const tipo = it.plataforma ? 'Desconto' : 'Impressão';
                const cidadeOrigem = it.cidadeOrigem ? it.cidadeOrigem.nomeComUf : ''
                const cidadeDestino = it.cidadeOrigem ? it.cidadeDestino.nomeComUf : ''

                let valor = `${it.nome};${it.email};${telefone};"${origem}";"${tipo}";"${cidadeOrigem}";"${cidadeDestino}";"${it.dataHora}"`

                return valor;

            }).join('\n')}\n`;

            from += 1;
            count += 1;

            if (count === totalParticoes) {
                this.executarDownload(arquivo)
            }
        }
    }

    exibirBotaoExportarLista() {
        return (
                <div className="row">
                    <div className="col-md-12">
                        <div className="text-right">
                            <button className="btn btn-laranja mr-2"
                                onClick={() => this.exportarListaUsuarios()}>
                                Exportar Lista
                            </button>
                        </div>
                    </div>
                </div>)
    }

    render() {
        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div>
                    <div className="row internas">
                        <Titulo texto="Gerenciar Interessados e Clientes" urlRetorno="/"/>
                        <div className='col-12 conteudo-internas conteudo-painel area-btn-filtro-painel'>
                            <div className="col-12 filtro-busca">
                                <PainelFiltragem/>
                            </div>
                            {this.exibirBotaoExportarLista()}
                            {this.exibirTabelaInteressados()}
                        </div>
                    </div>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        interessadosPromocao: state.interessadoPromocao.interessados,
        total: state.interessadoPromocao.total,
        paginaAtual: state.interessadoPromocao.paginaAtual,
        registrosPorPagina: state.interessadoPromocao.registrosPorPagina,
        changeFieldValue,
        filtrosAdicionados: state.interessadoPromocao.filtrosAdicionados
    });


export default connect(mapStateToProps, {
    buscarInteressadosPromocao,
    buscarPlataformas,
    determinarPaginaAtual,
    alterarRegistrosPorPagina,
    listarFiltros
})(reduxForm({
    form: 'formularioInteressados'
})(PainelGerenciarInteressadosPromocao))
